import { View } from "@react-pdf/renderer";
import {
  ResumePDFText,
  ProjectPDFLink,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { TemplateFivePDFSection, TemplateFivePDFSectionWithSubsections } from "./common";
import { ResumePDFIcon } from "components/Resume/ResumePDF/common/ResumePDFIcon";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeCertificate } from "lib/redux/types";

export const Certificate = ({
  heading,
  certifications,
  themeColor,
  isPDF,
  enableMistakeHighlight = false,
}: {
  heading: string;
  certifications: ResumeCertificate[];
  themeColor: string;
  isPDF: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateFivePDFSectionWithSubsections themeColor={themeColor} heading={heading}>
      {certifications.map(
        ({ certificate, certificateLink, descriptions }, idx) => (
          <View key={idx} wrap={false} style={idx > 0 ? { marginTop: "6pt" } : {}}>
            <View style={{ marginTop: "3pt" }}> {/* spacing["0.5"] (6pt) to 3pt */}
              <View
                style={{
                  marginTop: "3pt", // spacing["0.5"] (6pt) to 3pt
                }}
              >
                <View
                  style={{
                    ...styles.flexRow,
                    gap: "6pt", //spacing["2"] (24pt) to 6pt
                  }}
                >
                  <ResumePDFText bold={true} style={{ lineHeight: "1.2" }}>
                    {certificate}
                  </ResumePDFText>
                  {certificateLink && (
                    <ProjectPDFLink src={certificateLink}>
                      <ResumePDFIcon
                        type="url"
                        isPDF={isPDF}
                        themeColor={themeColor}
                      />
                    </ProjectPDFLink>
                  )}
                </View>
              </View>
              <View style={{ ...styles.flexCol, marginTop: "3pt" }}> {/* Reduced from spacing["0.5"] (6pt) to 3pt */}
                <ResumePDFDescription 
                  items={descriptions} 
                  enableMistakeHighlight={enableMistakeHighlight}
                  section="certifications"
                  itemIndex={idx}
                />
              </View>
            </View>
          </View>
        )
      )}
    </TemplateFivePDFSectionWithSubsections>
  );
};
